import axios from "axios";
import { url } from "./utils/url";
import authHeader from "./utils/auth-header";

export enum IStatusCodes {
  Pending = "PENDING_REVIEW",
  Scheduled = "SCHEDULED",
  Published = "PUBLISHED",
  Rejected = "REJECTED"
}
type IStatusID = IStatusCodes.Pending | IStatusCodes.Scheduled | IStatusCodes.Published | IStatusCodes.Rejected;
type IStatus = { id: IStatusID, label: string };
export interface IPost {
  id: string;
  read: boolean;
  title: string;
  message: string;
  createdBy: string;
  status: IStatus;
  images: string[];
  createdAt: string;
  publishedAt: string | null;
  updatedAt: string;
  isNeighbourPost: boolean;
}

class TenantCommunityInboxApi {
  static async getAll() {
    const result = await axios.get<{ posts: IPost[] }>(`${url}/admin/inbox`, {
      headers: authHeader(),
    });
    return result.data.posts;
  }

  static async create(body: any) {
    const result = await axios.post(`${url}/admin/inbox`, body, {
      headers: authHeader(),
    });
    return result.data;
  }

  static async update(id: any, body: any) {
    const result = await axios.put(`${url}/admin/inbox/${id}`, body, {
      headers: authHeader(),
    });
    return result.data;
  }

  static async upload(body: any) {
    const result = await axios.post(`${url}/admin/inbox/photo/upload`, body, {
      headers: authHeader(),
    });

    return result.data;
  }

  static async deleteImageSource(body: any) {
    const result = await axios.post(`${url}/admin/inbox/imageSource`, body, {
      headers: authHeader(),
    });

    return result.data;
  }
}

export default TenantCommunityInboxApi;
